import ErrorMessage from "../common-components/ErrorMessage";

interface InputCellProps {
  type?: "text" | "number";
  name: string;
  value?: string;
  handleChange?: (e: any) => void;
  colSpan?: any;
  errorMessage?: any;
}

const InputCell = ({
  type = "text",
  name,
  value = "",
  handleChange,
  colSpan = {},
  errorMessage,
}: InputCellProps) => (
  <td colSpan={colSpan} style={{ minWidth: "100px" }}>
    <div className="d-flex flex-column gap-1">
      <input
        // style={{ padding: "1px 5px" }}
        type={type}
        name={name}
        value={value}
        onChange={(e) => handleChange?.(e.target.value)}
      />
      <ErrorMessage message={errorMessage} />
    </div>
  </td>
);

export default InputCell;
